export default __webpack_public_path__ + "static/media/astro.e81f3115.svg";